import { inputClass } from './Field'

/**
 * An input with a fixed symbol printed inside its left edge.
 *
 * `+63` and `₱` are not values, they are the unit the box is measured in — and a customer
 * who has to type them is a customer being asked to know a format. Printed instead, the
 * question stops being *"what shape does it want?"* and becomes *"what is the number?"*
 *
 * Rendered as a sibling rather than as a placeholder or a value prefix, because both of
 * those can be typed over: a placeholder disappears at the first keystroke, and a prefix
 * living in the value has to be defended from every backspace.
 *
 * `aria-hidden`, and the label carries the meaning instead. A screen reader announcing
 * *"plus six three, number the rider will ring, edit text"* has put the unit before the
 * question.
 */
export default function Affixed({ affix, invalid, wide, children }) {
  return (
    <div className="relative flex items-center">
      <span
        aria-hidden="true"
        className={`absolute left-3.5 text-body pointer-events-none select-none tabular-nums
                    ${invalid ? 'text-alert' : 'text-ink-3'}`}
      >
        {affix}
      </span>

      {children}
    </div>
  )
}

/**
 * The input's own classes, padded to clear the affix.
 *
 * `wide` is for `+63`, which needs about three characters of room; the default suits a
 * single glyph like `₱`. Sized in rem rather than measured at runtime — a fixed symbol in
 * a fixed font does not need a ResizeObserver to sit still.
 */
export const affixedInputClass = (invalid, wide) =>
  `${inputClass(invalid)} ${wide ? 'pl-[3.25rem]' : 'pl-8'}`
